import { SearchResultDTO, TaskDTO } from './../../api/plyca-dtos';
import { Component, ElementRef, Input, Optional, AfterViewInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { UIService } from '../../ui.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { finalize, map, take } from 'rxjs/operators';
import { ActionDefinitionDTO, ActionParameterDefinitionDTO, InvoiceDTO, ProjectEntityDTO, SearchActionResultDTO } from '../../api/plyca-dtos-v2';
import { ActivatedRoute } from '@angular/router';
import { TaskHandler } from '../../tasks/TaskHandler';
import { InvoiceComponent } from './invoice.component';
import { getSimpleIdentifierFromString, DocumentDTO, DocumentStateDTO, ActionDTO } from '../../api/plyca-dtos';
import { documentViewerComponent } from '../../documents/documentViewer/documentViewer.component';
import { ServiceLocator } from '../../ServiceLocator';
import { ActionService } from '../../actions/action.service';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import { PropertyService } from '../../properties/property.service';
import { UserService } from '../../user.service';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { SearchConfig } from '../../api/contract-notice-dto';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { AppConfiguration } from '../../conf/app.configuration';


@Component({
  selector: 'invoices',
  templateUrl: 'invoices.template.html',
  providers: [DialogService, UIService]
})
export class InvoicesComponent extends TaskHandler implements AfterViewInit, OnDestroy {

  private loaded = false;
  elements: Array<InvoiceDTO>;
  dossierId: any;
  loteid: any;
  description: any;
  contractId: any;
  public totalFacturado: number;
  public totalAdjudicado: number;
  public mapResult: Map<string, InvoiceDTO[]>;
  private actionService: ActionService;
  private propertyService: PropertyService;
  private userService: UserService;

  @Input()
  project: ProjectEntityDTO;
  nifs = [];
  modalOpened: boolean;
  actions: ActionDefinitionDTO[];

  contractName: string;
  statesAllowEdit: string;
  propertyLoaded: boolean;


  constructor(
    private plycaErrorHandler: PlycaErrorHandler,
    private headerActionsService: HeaderActionsService, // Servicio para el componente sub-header título y botones
    private elem: ElementRef,                             // Referencia necesaria para el servicio anterior
    public plycaService: PlycaDataService,              // Servicio de accesoa REST de servidor
    public uiService: UIService,                       // Servicios de interfaz como: mostrar un mensaje, ...
    public waitService: WaitLoadingService,            // Servicio para mostrar la capa de espera mientras hay procesos que tarden
    // o haya que bloquear la pantalla
    // Al menos en todas las llamadas al servidor.
    // private translationService: TranslateService,        // Servicio para obtener los textos internacionalizados
    private configuration: Configuration,                  // Configuración de las urls de los REST de servidor
    //public router: Router,
    //public route: ActivatedRoute
    private appConfig: AppConfiguration,
    @Optional() protected activatedRoute: ActivatedRoute,
  ) {
    super();
    this.actionService = ServiceLocator.injector.get(ActionService);
    this.propertyService = ServiceLocator.injector.get(PropertyService);
    this.userService = ServiceLocator.injector.get(UserService);
    this.subscribe(this.propertyService.getProperty('FACTURA.GESTIONARTODAS.ESTADOSNOEDITABLES', 'ANULADO').pipe(
      finalize(() => {
        console.log('fasdfas');
      }))
      , (value: string) => {
        this.statesAllowEdit = value.replace(new RegExp(/[;]/g), ',');
        this.propertyLoaded = true;
      },
      (error) => {
        this.statesAllowEdit = 'ANULADO';
        this.propertyLoaded = true;
      });
  }

  loadConfig(): void {
    this.headerActionsService.clearActions();
    // Título de la página
    this.headerActionsService.setTaskDescription(
      this.elem,
      this.task.description,
      'fas fa-file-invoice-dollar',
      true);
    if (this.isModeData()) {
      // Botones de acción por orden de aparición de izquierda a derecha
      /*  if (this.task && this.task.work.context.configurations.isElectronicInvoice
          && this.task.work.context.configurations.isElectronicInvoice === true) {*/

      /*
      this.headerActionsService.addAction(
        'Invoices.import.text',
        'fas fa-file-import',
        'btn-secondary',
        true
      ).subscribe(() => {
        this.import();
      });


*/
      this.subscribe(this.propertyService.getProperty('ACTIVAR_IMPORTACION_FACTURAS', ''), (value: string) => {
        if (value && ('1' === value)) {
          if (this.appConfig.getValue('invoices.adapt.leganes.terceros.import')) {
            this.subscribe(this.headerActionsService.addAction(
              'Invoices.import.text',
              'fas fa-file-import',
              'btn-primary',
              true
            ), () => {
              this.importar();
            });
            this.generalActions();
          } else {
            this.subscribe(this.plycaService.getAvailableAction('IMPORT_INVOICE', this.userService.getUserId(), 'USER').pipe(finalize(() => {
              this.generalActions();
              // this.waitService.cancelWaiting(); // Al finalizar (ok o con error)  se cancela la capa de espera.
            })), (datos: any) => {
              if (datos && datos.actions) {
                datos.actions.forEach(action => {
                  /*
                      actions.actions
                        .filter((action: ActionDTO) => action.enabled)
                        .filter((action: ActionDTO) =>
                          filterFunction ? filterFunction.call(this, action) : true
                        )
                        .forEach((action: ActionDTO) => activeActions.actions.push(action));
                  */
                  this.subscribe(this.headerActionsService.addAction(
                    action.name,
                    this.actionService.getActionIconClass(action),
                    'btn-secondary',
                    true
                  ), success => {
                    this.openModalAction(action, this.task).onClose.pipe(take(1)).subscribe(() => this.reload());
                  });
                });
              }
            });
          }
        } else {
          this.generalActions();
        }
      });
    } else if (this.isModeValida()) {
      this.subscribe(this.headerActionsService.addAction(
        'Invoices.validate.text',
        'fas fa-check',
        'btn-primary',
        true
      ), () => {
        this.processTask(false);

      });
    }
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  private generalActions() {
    this.subscribe(this.headerActionsService.addAction(
      'Invoices.add',
      'fas fa-plus',
      'btn-primary',
      true
    ), () => {
      this.edit('new');
    }, (error) => {
      console.log(error);
    });
    this.subscribe(this.headerActionsService.addAction(
      'General.accept',
      'fas fa-check',
      'btn-primary',
      true
    ), () => {
      this.processTask(false);
    });
  }





  public importar(): void {
    let parametersURL: ActionParameterDefinitionDTO[] = [];
    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'INTEGRATIONINVOICES.OPERADORECONOMICO';
    if (this.task?.work['contract']?.company) {
      param1.value = this.task?.work['contract']?.company?.taxIdentifier;
      parametersURL.push(param1);
    }

    let completedResult = true;
    let autoSearch = false;
    let searchConfig = new SearchConfig();
    searchConfig.multiSelection = true;
    searchConfig.actionCfg = {
      rowFn: this.rowFnImportar.bind(this),
      //postExecuteFn: this.postExcuteFnImportar.bind(this)
    };

    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONINVOICES',
      autoSearch,
      parametersURL,
      completedResult,
      searchConfig
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;

    const ref = this.dialogService.open(searchGenericComponent, config);

    this.subscribe(ref.onClose,
      () => {
        console.log('************ reload*********************************');
        this.reload();
      },
      (error) => {
        console.log(error);
      })
    /* this.subscribe(ref.onClose,
       (_searchResult: InvoiceDTO) => {
         this.addInvoice(_searchResult);
         console.log('is SearchSelectionResultDTO: ', _searchResult);
       },
       (error) => {
         //throw error;
         this.plycaErrorHandler.showServerError(error);
         console.log("Se ha producido un error al capturar la factura al expediente de contratación." + error);
       });
       */
  }

  /*  public postExcuteFnImportar(row: SearchResultDTO) {
      console.log('************ postExcuteFnImportar*********************************');
      return of(this.reload());
    }*/
  public rowFnImportar(row: SearchResultDTO) {
    console.log('************ rowFnImportar*********************************');
    let doc = row.singleValue;
    return this.addInvoice(doc);
  }

  private addInvoice(invoice: InvoiceDTO) {
    console.log('addInvoice ', invoice);
    if (invoice) {
      // TODO
      // ¿Qué pasa cuando no sea tarea?
      if (this.task) {
        //let division = new DivisionDTO();

        invoice.division = this.task.division;
        //let divisionIdentifier = this.task.division.divisionIdentifier;
        //let projectIdentifier = this.task.work.projectIdentifier;
        //let divisionIdentifier2 = this.task.work.divisionIdentifier;
        //this.loteid = getSimpleIdentifierFromString(this.task.division.identifier);
        //division.identifier = this.task.work.divisionIdentifier + '<>' + this.dossierId;
        //doc.division = division;

        invoice.task = {} as TaskDTO;
        invoice.task.identifier = this.task.identifier; // Para que incluye el nuevo numorden en la variable de la tarea
      }

      let url = this.configuration.INVOICES_SERVICE_URL;

      /* this.waitService.startWaiting();
       this.subscribe(this.plycaService.insert<InvoiceDTO>(url, invoice).pipe(
         finalize(
           () => {
             this.reload();
             this.waitService.cancelWaiting();
           })),

         () => {
         },
         (error) => {
           this.plycaErrorHandler.showServerError(error);
           console.log("Se ha producido un error al capturar la factura al expediente de contratación." + error);
         });
     }*/
      return this.plycaService.insert<InvoiceDTO>(url, invoice).pipe(
        map((result: InvoiceDTO) => {
          let actionResult = new SearchActionResultDTO();
          actionResult.success = true;
          actionResult.objectResult = result;
          return actionResult;
        })
      );
    }
  }

  // Método para inicializar el componente sub-header y habitualmente también el contexto de la ayuda.
  ngAfterViewInit(): void {


    this.description = this.task.work.thirdPartyDescription;
    this.contractName = this.task.division.name;
    // Carga de los datos del componente, normalmente desde servidor.
    this.load();

  }
  load() {
    this.waitService.startWaiting();


    if (this.task) {
      this.elements = this.task.work.invoices || [];
      this.contractId = this.task.division.project.contractFolderId;
      this.calculaTotales();
      this.loadConfig();
      this.waitService.cancelWaiting();
      this.loaded = true;
    } else {
      this.subscribe(this.plycaService
        .query<InvoiceDTO>(this.configuration.INVOICES_SERVICE_URL, this.getParams())
        .pipe(finalize(() => {
          this.waitService.cancelWaiting(); // Al finalizar (ok o con error)  se cancela la capa de espera.
        })),
        (value: any) => {
          if (value && value.content) {
            this.elements = value.content;

          } else {
            this.elements = [];
          }
          this.calculaTotales();
          this.loadConfig();
          this.waitService.cancelWaiting();
          this.loaded = true;
        });

    }
    this.agrupar(this.elements);

    this.nifs = Array.from(this.mapResult.keys());
    // Se marca el elemento como cargado para mostrar los datos en el template




  }
  agrupar(invoices: InvoiceDTO[]) {
    // let mapResult = new Map();

    this.mapResult = new Map<string, []>();


    invoices.map((invoice) => {
      if (!this.mapResult.get(invoice.taxIdentifier)) {

        this.mapResult.set(invoice.taxIdentifier, []);
      }
      this.mapResult.get(invoice.taxIdentifier).push(invoice);



    });


  }



  calculaTotales() {
    if (this.task.work.context.configurations.TOTALFACTURADO) {

      this.totalFacturado = this.task.work.context.configurations.TOTALFACTURADO.value;

    } else {
      this.totalFacturado = 0;
      this.elements.filter(param => param.totalAmount)
        .map(
          param => {
            if (param.document.currentState.identifier !== 'ANULADO' && param.document.currentState.identifier != 'RECTIFICADA') {
              this.totalFacturado = this.totalFacturado + param.totalAmount
            }
          }
        );

    }



    this.totalAdjudicado = this.task.work.context.configurations.TOTALADJUDICADO.value;

  }
  isLoaded(): boolean {
    return this.propertyLoaded && this.loaded;
  }
  isLoadedResult() {
    return this.isLoaded() && (this.elements && this.elements.length > 0);
  }

  edit(id, readonly: boolean = false) {
    let config: DynamicDialogConfig = {
      header: 'Edición de factura',
      width: '90%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'

    };

    this.dossierId = this.task.division.project.identifier;
    this.loteid = getSimpleIdentifierFromString(this.task.division.identifier);
    config['task'] = this.task;
    config['taskWork'] = this.task.work;
    config['id'] = id;
    config['projectId'] = this.task.work.projectIdentifier;
    config['loteId'] = this.task.work.divisionIdentifier;
    //this.totalFacturado>this.task.division.project.budget.totalAmount
    config['contractTotal'] = this.totalAdjudicado;
    config['invoicesTotal'] = this.totalFacturado;

    // ASIER
    //this.readonly = dialogConfig['readonly'] ? dialogConfig['readonly'] : true;
    config['readonly'] = readonly;

    const dialog = this.dialogService.open(InvoiceComponent, config);
    dialog.onClose.subscribe(newInvoice => {
      if (!readonly) {
        this.reload();
      }


    });

  }

  private reload() {
    this.loaded = false;
    this.waitService.startWaiting();
    if (this.task) {
      this.subscribe(this.taskService.saveWork(this.task, this.task.work.reactive), result => {
        this.task = result;
        this.load();
      });
    }
    else {
      this.load();
    }
  }


  public showDocument(documento: DocumentDTO): void {
    let config: DynamicDialogConfig = {
      header: documento.name,
      width: '97%',
      styleClass: 'searchStyle'
    };

    config.data = {
      'id': documento.identifier,
      'version': documento.currentVersion.versionNumber
    }
    this.waitService.startWaiting();
    let modal = this.dialogService.open(documentViewerComponent, config);
    modal.onClose.pipe(take(1)).subscribe();
  }
  reject(id) {
    let config: DynamicDialogConfig = {
      header: 'Rechazar factura',
      width: '90%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'

    };

    this.dossierId = this.task.division.project.identifier;
    this.loteid = getSimpleIdentifierFromString(this.task.division.identifier);
    config['task'] = this.task;
    config['taskWork'] = this.task.work;
    config['id'] = id;
    config['projectId'] = this.task.work.projectIdentifier;
    config['loteId'] = this.task.work.divisionIdentifier;
    config['readonly'] = true;
    config['accion'] = 'REJECT';
    config['REJECTID'] = this.task.work.context.configurations.PREANULADOstate;
    const a = this.dialogService.open(InvoiceComponent, config);
    a.onClose.pipe(take(1)).subscribe(newInvoice => {
      this.reload();


    });



  }
  rectify(id) {
    let config: DynamicDialogConfig = {
      header: 'Rectificar factura',
      width: '90%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'

    };

    this.dossierId = this.task.division.project.identifier;
    this.loteid = getSimpleIdentifierFromString(this.task.division.identifier);
    config['task'] = this.task;
    config['taskWork'] = this.task.work;
    config['id'] = id;
    config['projectId'] = this.task.work.projectIdentifier;
    config['loteId'] = this.task.work.divisionIdentifier;
    config['readonly'] = true;
    config['accion'] = 'RECTIFY';
    const a = this.dialogService.open(InvoiceComponent, config);
    a.onClose.subscribe(newInvoice => {
      this.reload();


    });

  }





  getStatusColor(state: DocumentStateDTO): string {
    let ret = 'badge ';
    try {
      let stateId = getSimpleIdentifierFromString(state.type.identifier);
      if (stateId === 'ANULADO') {
        ret += 'badge-danger';
      } else if (stateId === '1') {
        ret += 'badge-secondary';
      } else if (stateId === 'RECTIFICADA') {
        ret += 'badge-warning';
      } else {
        ret += 'badge-secondary';
      }
      return ret;
    } catch (ex) {
      return '';
    }
  }


  getParams() {

    return {

      dossierId: this.dossierId,
      loteid: this.loteid

    }
  }


  isShowEdit(inv: InvoiceDTO): boolean {
    //let show = this.isModeData() && !inv.externalCode && this.currentStateAllowEdits(inv.document.currentState.identifier);
    let show = this.isModeData() && this.currentStateAllowEdits(inv.document.currentState.identifier);
    return show;
  }
  isShowRectify(inv: InvoiceDTO): boolean {
    let show = inv.document.currentState.identifier !== 'ANULADO' && inv.document.currentState.identifier !== 'RECTIFICADA'
      && this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.showRectify
      && this.task.work.context.configurations.showRectify.value;
    show = show && this.isModeData();
    return show;
  }

  isShowReject(inv: InvoiceDTO): boolean {

    let show = inv.document.currentState.identifier !== 'ANULADO'
      && this.task.work.context && this.task.work.context.configurations && this.task.work.context.configurations.showReject
      && this.task.work.context.configurations.showReject.value;

    show = show && inv && inv.context.configurations && (
      (inv.context.configurations.isProcurementProject
        && inv.context.configurations.isProcurementProject.value === true)
      || (inv.context.configurations.isPublicSector
        && inv.context.configurations.isPublicSector.value === true)
    );

    // Que tenga definido el estado preanulado en atributos
    show = show && inv.context.configurations.PREANULADOstate && inv.context.configurations.PREANULADOstate.value
    show = show && this.isModeData();


    /*

         if (UtilidadesScript.esGENFEScript() || UtilidadesScript.esGENSPFEScript()) {
            //boolean cambio = false;
            //factura.setUser(usuario);
            short numFila = (short) getJTable().getSelectedRow();
            if (mostrarMensaje((byte) 5) == 0) {   // El usuario est� conforme con la baja
                try {
                    String estado = null;
                    if (factura.getCodigoExterno() == null || factura.getCodigoExterno().trim().equals("")) {
                        estado = GestGasto.ANULADO;
                    } else {
                        estado = estadoPreanulado;
                    }
                    estableceEstadoSinCicloVida(factura, estado);
                    cargarTabla();
                    getJTable().setRowSelectionInterval(numFila, numFila);
                    //cambio = true;
                } catch (Exception e) {
                    mostrarMensaje((byte) 17);
                }
            }


        }

    */


    return show;
  }

  isModeValida(): boolean {
    return this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.modeVALIDA
      && this.task.work.context.configurations.modeVALIDA.value
  }

  isModeData(): boolean {
    return this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.modeDATA
      && this.task.work.context.configurations.modeDATA.value
  }

  openModalAction(action: ActionDTO, task: TaskDTO) {

    let config: DynamicDialogConfig = {
      header: action.name,

      width: '70%',
      styleClass: 'actionStyle',
      style: { overflow: 'hidden' }


    };
    config['action'] = action;

    action.parameters.find((a) => a.name == 'DIVISION').value = this.task.work.divisionIdentifier;
    action.parameters.find((a) => a.name == 'PROPUESTAID').value = this.task.work.projectIdentifier;
    action.parameters.find((a) => a.name == 'TASKID').value = task.identifier;
    action.parameters.find((a) => a.name == 'TASKID').editable = false;
    action.parameters.find((a) => a.name == 'DIVISION').editable = false;
    action.parameters.find((a) => a.name == 'PROPUESTAID').editable = false;




    return this.dialogService.open(ActionsProcessComponent, config);


  }

  currentStateAllowEdits(currentStateId: string) {
    let ret = false;

    if (this.task.work.context.configurations.manageAllInvoices && this.task.work.context.configurations.manageAllInvoices.value) {
      if (this.statesAllowEdit != undefined) {

        let list = this.statesAllowEdit.split(',');
        let obj = list.find(id => id == currentStateId)
        ret = obj == undefined;

      }
    } else {

      ret = currentStateId !== 'ANULADO';
    }




    return ret;

  }
}
